
import { ResultsWidget } from "../ResultsWidget";
import { ResultsController } from "../Tools/ResultsController";
import { ResultsOverlayWidget } from "./ResultsOverlayWidget";
declare var Savane: any;
declare var PlanManager: any;
declare var ActionStateEnum: any;
declare var AssetManagerServices: any;
export class ResourceWidget {
    static controller: ResultsController = new ResultsController();
    static hideTooltipListener: any;
    static stateListener: any;

    static resizeFunc() {
        ResultsWidget.hideTooltip();
        $('.resourceItem').each((_idx, element) => {
            $(element).css('height', ResultsWidget.itemSize + 'px');
            $(element).css('width', ResultsWidget.itemSize + 'px');
        });

    };

    static oldState: any = null;

    static html(resources: any[]): string {
        //Launch on start
        if (ResourceWidget.hideTooltipListener) {
            Savane.eventsManager.instance.removeListener(ResourceWidget.hideTooltipListener);
        }

        if (ResourceWidget.stateListener) {
            Savane.eventsManager.instance.removeListener(ResourceWidget.stateListener);
        }

        ResourceWidget.hideTooltipListener = Savane.eventsManager.instance.addListener(Savane.Events.HIDE_TOOLTIP_EVENT, () => ResultsWidget.hideTooltip());
        ResourceWidget.stateListener = Savane.eventsManager.instance.addListener(Savane.Events.PLAN_STATE_CHANGED, () => {
            const instance = PlanManager.getInstance();
            if (ResourceWidget.oldState === instance.getAction()) return;
            if (instance.getAction() === ActionStateEnum.idleDecoration && ResourceWidget.oldState === ActionStateEnum.DrawWorkTop) {
                setTimeout(() => {
                    ResourceWidget.controller.destroy();
                    ResultsWidget.controller.destroy();
                    ResultsWidget.html();
                }, 50);
            } else if (instance.getAction() === ActionStateEnum.DrawWorkTop) {
                ResultsWidget.controller.destroy();
                ResourceWidget.controller.destroy();
            } else return;
            ResourceWidget.oldState = instance.getAction();
            ResultsWidget.hideTooltip();
        });
        $(window).on('resize', ResourceWidget.resizeFunc);

        let resultHtml = '';
        if (resources === null || resources === undefined || resources.length === 0) {
            return resultHtml;
        }
        resources.forEach((resource) => {
            resultHtml += `
            <div class="resourceItem listResults-${resource._id}"
                style="background-color: #efefef; background-position: 50% 50%; background-size: cover;"
                data-drag="${ResultsWidget.draggableEntities}">
            `;
            let overlay = new ResultsOverlayWidget(ResultsOverlayWidget.openUrl, ResultsWidget.openDetailsFunc, resource);
            resultHtml += overlay.html() + '</div>';
            setTimeout(() => {
                ResourceWidget.controller.addEventListeners('mouseenter', (event) => { ResultsWidget.displayTooltip(resource, event) }, `listResults-${resource._id}`, undefined, true);
                ResourceWidget.controller.addEventListeners('mouseleave', () => { ResultsWidget.hideTooltip() }, `listResults-${resource._id}`, undefined, true);

                const elements = document.querySelectorAll(`.listResults-${resource._id}`);
                if (elements.length !== 0) {
                    elements.forEach((elem) => {
                        $(elem).draggable({
                            start: (ui, item) => { ResultsWidget.startDrag(ui, item, resource) },
                            revert: 'invalid',
                            helper: 'clone',
                        });
                    })
                }
            }, 50);

            setTimeout(() => {
                ResourceWidget.setResourceUrl(resource);
            }, 0);
        });
        setTimeout(() => {
            ResourceWidget.resizeFunc();
        }, 50);
        return resultHtml;
    }

    static removeListeners(resources: any[] | null) {
        if (resources === null) return;
        resources.forEach((resource) => {
            ResourceWidget.controller.removeEventListeners('mouseenter', `listResults-${resource._id}`);
            ResourceWidget.controller.removeEventListeners('mouseleave', `listResults-${resource._id}`);
            const elements = document.querySelectorAll(`.listResults-${resource._id}`);
            if (elements.length !== 0) {
                elements.forEach((elem) => {
                    if ($(elem).draggable) {
                        $(elem).draggable('destroy');
                    }
                })
            }
        });
    }

    static setResourceUrl(resource: any) {
        if (resource === undefined || resource === null) return;
        var configIndex = ResultsWidget.getDecorationService().getFilteredConfig(resource);
        var filename: string;
        var path: string;

        Savane.eventsManager.instance.dispatch(Savane.Events.STOP_UPDATING_ENVS);
        //Search in media the default preview
        switch (ResultsWidget.getDecorationService().group) {
            case AssetManagerServices._ASSET_TYPE.ARRANGEMENTS:
                filename = 'preview' + configIndex + '-sm.webp';
                if (AssetManagerServices.getMediaUrl().indexOf("media") === -1) {
                    path = 'assets';
                }
                else {
                    path = 'arrangements';
                }
                break;

            case AssetManagerServices._ASSET_TYPE.JOINERIES:
                filename = 'preview1-sm.jpg';
                path = 'joineries';
                break;

            case AssetManagerServices._ASSET_TYPE.TECHNICAL_ELEMENTS:
                filename = 'preview1-sm.jpg';
                path = 'technicalelements';
                break;

            case AssetManagerServices._ASSET_TYPE.TEMPLATES:
                filename = 'preview1-sm.jpg';
                path = 'assets_groups';
                break;

            case AssetManagerServices._ASSET_TYPE.COATINGS:
                filename = 'preview' + configIndex + '-sm.webp';
                path = 'coatings';
                break;

            case AssetManagerServices._ASSET_TYPE.ALL:
                filename = 'preview' + configIndex + '-sm.webp';
                path = 'allAssets';

            case 'nextobjects':
            case 'magicsearch':
                switch (resource.kind) {
                    case 'Arrangement':
                        filename = 'preview' + configIndex + '-sm.webp';
                        if (AssetManagerServices.getMediaUrl().indexOf("media") === -1) {
                            path = 'assets';
                        }
                        else {
                            path = 'arrangements';
                        }
                        break;

                    case 'Joinery':
                        filename = 'preview1-sm.jpg';
                        path = 'joineries';
                        break;

                    case 'TechnicalElement':
                        filename = 'preview1-sm.jpg';
                        path = 'technicalelements';
                        break;

                    case 'Template':
                        filename = 'preview1-sm.jpg';
                        path = 'assets_groups';
                        break;

                    case 'Coating':
                        filename = 'preview' + configIndex + '-sm.webp';
                        path = 'coatings';
                        break;

                    default:
                        break;
                }
                break;
        }
        // var url = AssetManagerServices.getUrl() + 'api/v1/' + path + '/' + resource._id + '/medias/previews/' + filename; //resource.medias[imgIndex];

        var url = AssetManagerServices.getMediaUrl() + path + '/' + resource._id + '/medias/previews/' + filename;
        let elements = document.querySelectorAll(`.listResults-${resource._id}`);
        let element = elements.item(elements.length - 1);

        $(element).css({
            'background-image': 'url(' + url + ')'
        });
        setTimeout(() => {
            let elements = document.querySelectorAll(`#empty-${resource._id}`);
            let element = elements.item(elements.length - 1);
            $(element).css('display', '');
        }, 50);
        Savane.eventsManager.instance.dispatch(Savane.Events.START_UPDATING_ENVS);
    }

    static destroy() {
        Savane.eventsManager.instance.removeListener(ResourceWidget.hideTooltipListener);
        Savane.eventsManager.instance.removeListener(ResourceWidget.stateListener);
        $(window).off('resize', ResourceWidget.resizeFunc);
        ResourceWidget.controller.destroy();
    }
}